// extracted by mini-css-extract-plugin
export default {"thumbnail":"ffaf87c9bd0e","wholepage":"e59c00285cf0"};